import { c as _c } from "react/compiler-runtime";
import css from '@app/registration/(with-padding)/_components/layoutRestrictedBackground.module.css';
import { baseUrl } from '@util/assets';
import { ReactElement } from 'react';
const style = {
  backgroundImage: `url(${baseUrl}images/registration/background/entry-v3-1920x1080.jpg)`
};
export const LayoutRestrictedBackground = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.layoutRestrictedBackground} style={style} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};